import { AutorAdminBeanUpdRequest } from 'src/app/modal/autor/autorAdminBean';
import { AnioAdminBeanUpdRequest } from 'src/app/modal/anio/anioAdminBean';
import { ModalidadBean, ModalidadBeanRequest } from '../modalidad/modalidad-bean';

export class LibroBeanUpdRequest{
     authorName :  string ;
        authorsIds : [
            {
            about :  string ,
            enabled :  string ,
            id :  string ,
            name :  string ,
            order :  string ,
            usuarioModificaId :  string 
            }
        ];
        categoryId :  string ;
        categoryName :  string ;
        codigoActivo :  string ;
        description :  string ;
        // daet ini
        descriptionE :  string ;
        // daet fin
        diarioId :  string ;
        codigoProducto: string;
        diarioName :  string ;
        editionsIds : [
            {
            about :  string ,
            enabled :  string ,
            id :  string ,
            name :  string ,
            order :  string ,
            usuarioModificaId :  string 
            }
        ];
        enabled :  string ;
        fechaCreation :  string ;
        height :  string ;
        id :  string ;
        igv_base :  string ;
        image :  string ;
        isbn :  string ;
        isnn :  string ;
        measure :  string ;
        modalidadId :  string ;
        modalidadName :  string ;
        modalidadesIds : Array<ModalidadBean>;
        novelty :  string ;
        order :  string ;
        originalUrl :  string ;
        pages :  string ;
        photo64 :  string ;
        previewUrl :  string ;
        price :  string ;
        price_base :  string ;
        publicationId :  string ;
        publishedDate :  string ;
        quantity :  string ;
        resolucionId :  string ;
        resolucionName :  string ;
        state :  string ;
        stock :  string ;
        subCategoryName :  string ;
        subTitle :  string ;
        subject :  string ;
        tags :  string ;
        thumbnail :  string ;
        title :  string ;
        usuarioCrearId :  string ;
        usuarioModificaId :  string ;
        weight :  string ;
        weightView :  string ;
        width :  string   
        constructor(){
            
            this.authorName=""
            this.authorsIds=[{
                about :  "" ,
                enabled :  "" ,
                id :  "" ,
                name :  "" ,
                order :  "" ,
                usuarioModificaId :  "" 
                }
            ];
        this.categoryId=  "" ;
        this.categoryName=  "" ;
        this.codigoActivo=  "" ;
        this.description=  "" ;
        this.diarioId=  "" ;
        this.diarioName=  "" ;
        this.editionsIds= [{
            about :  "" ,
            enabled :  "" ,
            id :  "" ,
            name :  "" ,
            order :  "" ,
            usuarioModificaId :  "" 
            }
        ];
        this.enabled=  "" ;
        this.fechaCreation=  "" ;
        this.height=  "" ;
        this.id=  "" ;
        this.igv_base=  "" ;
        this.image=  "" ;
        this.isbn=  "" ;
        this.isnn=  "" ;
        this.measure=  "" ;
        this.modalidadId=  "" ;
        this.modalidadName=  "" ;       
        this.novelty=  "" ;
        this.order=  "" ;
        this.originalUrl=  "" ;
        this.pages=  "" ;
        this.photo64=  "" ;
        this.previewUrl=  "" ;
        this.price=  "" ;
        this.price_base=  "" ;
        this.publicationId=  "" ;
        this.publishedDate=  "" ;
        this.quantity=  "" ;
        this.resolucionId=  "" ;
        this.resolucionName=  "" ;
        this.state=  "" ;
        this.stock=  "" ;
        this.subCategoryName=  "" ;
        this.subTitle=  "" ;
        this.subject=  "" ;
        this.tags=  "" ;
        this.thumbnail=  "" ;
        this.title=  "" ;
        this.usuarioCrearId=  "" ;
        this.usuarioModificaId=  "" ;
        this.weight=  "" ;
        this.weightView=  "" ;
        this.width=  "" 
        }
}